import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { loadMongoData } from '@adornis/baseql/server/data-loader.js';
import { type BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { Institution } from '@adornis/buchungsheld-db/entities/institution.js';
import type { User } from '@adornis/buchungsheld-db/entities/user.js';
import { Permission } from '@adornis/buchungsheld-db/enums/roles.js';
import { CurrentUserInfo } from '@adornis/users/db/currentUserInfo.js';
import { AdornisRoleToContextsWrapper } from '@adornis/users/db/roleToContextsWrapper.js';

export const getAvailableInstitutions = registerMutation({
  operationName: 'getActiveInstitutions',
  type: () => [Institution],
  params: [{ name: 'availableFor', type: () => String }],
  resolve: (availableFor: 'ORDER_WORKSHOPS_FROM' | 'EDIT') => {
    return async (gqlFields: BaseQLSelectionSet<Institution>) => {
      const institutions = await loadMongoData(Institution, { hidden: { $ne: true } });

      if (availableFor === 'EDIT') {
        const user = await CurrentUserInfo.getMyself<User>()({ roles: AdornisRoleToContextsWrapper.allFields });
        return institutions.filter(i => user?.hasPermission(Permission.MANAGE_INSTITUTION, i._id));
      }

      return institutions;
    };
  },
});
